import { ROLE_COLORS, ROLE_LABELS } from "./constants";

export function RoleLegend() {
  return (
    <div className="flex flex-wrap gap-3 px-2 py-2 rounded-lg bg-muted/30 border text-xs">
      {Object.entries(ROLE_COLORS).map(([role, color]) => (
        <div key={role} className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded-sm inline-block" style={{ backgroundColor: color }} />
          <span className="text-muted-foreground">{ROLE_LABELS[role] || role}</span>
        </div>
      ))}
    </div>
  );
}
